import PageRoot from 'app/KinerjaKSPage/components/EvaluationResultV2/PageRoot'
import PageHeader from 'app/KinerjaKSPage/components/EvaluationResult/PageHeader'
import EvaluationResultHeader from 'app/KinerjaKSPage/components/EvaluationResultV2/EvaluationResultHeader'
import EvaluationResultRoot from 'app/KinerjaKSPage/components/EvaluationResultV2/EvaluationResultRoot'
import EvaluationResultInfo from 'app/KinerjaKSPage/components/EvaluationResultV2/EvaluationResultInfo'
import EvaluationResultDetails from 'app/KinerjaKSPage/components/EvaluationResultV2/EvaluationResultDetails'
import EvaluationResultSummary from 'app/KinerjaKSPage/components/EvaluationResultV2/EvaluationResultSummary'
import PageError from 'app/KinerjaKSPage/components/EvaluationResultV2/PageError'
import PageSpinner from 'app/KinerjaKSPage/components/EvaluationResultV2/PageSpinner'
import PageContent from 'app/KinerjaKSPage/components/EvaluationResultV2/PageContent'
import EvaluationResultContent from 'app/KinerjaKSPage/components/EvaluationResultV2/EvaluationResultContent'

const EvaluationResult = {
  Root: PageRoot,
  Header: PageHeader,
  Content: PageContent,
  Spinner: PageSpinner,
  Error: PageError,

  // Result
  Result: {
    Root: EvaluationResultRoot,
    Header: EvaluationResultHeader,
    Content: EvaluationResultContent,
    Info: EvaluationResultInfo,
    Details: EvaluationResultDetails,
    Summary: EvaluationResultSummary,
  },
}

export default EvaluationResult
